module.exports = __webpack_public_path__ + "static/media/__to_add.f30a7b79.svg";